import type { SubmitFailure } from './api'

// 送出失敗時要給使用者看的話。分派的依據是 api.ts 判出的語意，不是 HTTP 狀態碼 —— 這裡只負責
// 「怎麼講」，「發生了什麼」是 API 邊界的事。表以 SubmitFailure 為 key，所以那邊多一種失敗、
// 這裡就編不過。
// 拿問卷失敗一律直接收合不顯示訊息（見 survey-element.load()），故無 load 文案。
const SUBMIT_COPY: Record<SubmitFailure, string> = {
  invalid: '送出的資料有誤,請檢查後再試。',
  duplicate: '您已經填過這份問卷了。',
  unknown: '送出失敗,請稍後再試。',
}

export function submitErrorMessage(reason: SubmitFailure): string {
  return SUBMIT_COPY[reason]
}
